export default __webpack_public_path__ + "b9cf0b0aa60677b0cbf4a6d163477e48.png";